import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DialogService, FormNavigationService, SpinnerService } from 'dspx-core';

import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { TEMPLATES } from '../../constants/templates.constants';
import { QUESTION_PATHS } from '../../constants/app-data.constants';

import { GridFilterRequest } from '../../interfaces/grid-filter-request.interface';

import { ServiceWorkerService } from '../../services/service-worker.service';
import { AppDataService } from '../../services/app-data.service';
import { ExcelImportService } from '../../services/excel-import.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { HtmlHelperService } from '../../services/html-helper.service';

import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';

@Component({
  selector: 'app-team-list',
  templateUrl: './team-list.component.html',
  styleUrls: ['./team-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TeamListComponent extends BaseCardSetListComponent implements OnInit, OnDestroy {

  activeDialog: string = '';

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected serviceWorkerService: ServiceWorkerService,
    protected appDataService: AppDataService,
    protected spinnerService: SpinnerService,
    protected htmlHelperService: HtmlHelperService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected excelImportService: ExcelImportService,
    protected formNavigationService: FormNavigationService) {
    super(
      router,
      serviceWorkerService,
      appDataService,
      spinnerService,
      htmlHelperService,
      dialogService,
      responseParserService,
      formNavigationService);

    this.initialise(
      TEMPLATES.teamList,
      () => API_ENDPOINTS.dashboard.getTeams,
      true);
  }

  ngOnInit(): void {
    this.ignoreCanDeactivateGuard = true;
    this.overrideHtmlTitleSetByDspxFrameworkOnFormNavigation();
    this.waitForServiceWorker();
  }

  ngOnDestroy(): void {
    this.completeDestroy();
  }

  formLoad(event: any): void {
    this.configData = event.configData;
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    const filterRequest = this.getFilterRequest();
    this.loadGridData(filterRequest);
  }

  private getFilterRequest(): GridFilterRequest {
    const searchQuestionModel = this.getQuestionValue(this.model, ...QUESTION_PATHS.teamList.search);

    const filterRequest: GridFilterRequest = {
      searchTerm: searchQuestionModel
    };

    return filterRequest;
  }

  actionButton_teamPlaceholder_datagrid_custom_customAdd_Clicked(event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.team.prefix]);
  }

  actionButton_teamPlaceholder_datagrid_edit_Clicked(event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.team.prefix, event.event.data.id]);
  }
}
